import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Centers from './views/Centers.vue';
import Center from './views/Center.vue';
import SelectGame from './views/SelectGame.vue';
import FootbowlGame from './views/FootbowlGame.vue';
import Account from './views/Account.vue';
import Health from './views/Health.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        hideNav: false,
      },
    },
    {
      path: '/footbowl/:center/lane/:lane',
      name: 'footbowl',
      component: FootbowlGame,
      meta: {
        hideNav: true,
      },
    },
    {
      path: '/footbowl/:gameId',
      name: 'footbowlById',
      component: FootbowlGame,
      meta: {
        hideNav: true,
      },
    },
    {
      path: '/centers',
      name: 'centers',
      component: Centers,
    },
    {
      path: '/center/:centerCodeOrId',
      name: 'center',
      component: Center,
    },
    {
      path: '/selectGame',
      name: 'selectGame',
      component: SelectGame,
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
    },
    {
      path: '/health',
      name: 'health',
      component: Health,
    },
  ],
});
